import { useTranslation } from "react-i18next";
import LoanRegisterButton from "../../../components/button/LoanRegisterButton";
import { useIsDesktop } from "../../../hooks/useIsDesktop";

const FifthSection = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation("fifthPart");

  return (
    <section
      style={{
        backgroundColor: "#111111",
        color: "#fff",
        padding: 0,
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "flex",
          flexDirection: isDesktop ? "row" : "column",
          alignItems: "stretch",
        }}
      >
        {/* Left — Video + Customer names */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Customer name top */}
          <div
            style={{
              padding: "16px 24px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span style={{ color: "var(--color-primary, #FF6500)", fontSize: "18px" }}>—</span>
            <span style={{ fontSize: "14px", fontWeight: 500 }}>คุณ สาระ ล่ำซำ</span>
          </div>

          {/* YouTube Video */}
          <div style={{ width: "100%", aspectRatio: "16/9" }}>
            <iframe
              src="https://www.youtube.com/embed/JXjvfOprAag?rel=0"
              title="เสียงตอบรับจากลูกค้า CTS"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>

          {/* Customer name bottom */}
          <div
            style={{
              padding: "16px 24px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span style={{ color: "var(--color-primary, #FF6500)", fontSize: "14px" }}>＋</span>
            <span style={{ fontSize: "14px", fontWeight: 500 }}>คุณ เอิร์น จิรวรรณ</span>
          </div>
        </div>

        {/* Right — Text content */}
        <div
          style={{
            flex: isDesktop ? "0 0 400px" : "1",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: isDesktop ? "60px 48px" : "32px 24px",
          }}
        >
          {/* TESTIMONIALS label with red line */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "24px",
            }}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: 500,
                letterSpacing: "2px",
                textTransform: "uppercase",
              }}
            >
              TESTIMONIALS
            </span>
            <span
              style={{
                display: "inline-block",
                width: "40px",
                height: "2px",
                backgroundColor: "#E53E3E",
              }}
            />
          </div>

          {/* Main heading */}
          <h2
            style={{
              fontSize: isDesktop ? "36px" : "28px",
              fontWeight: 700,
              lineHeight: 1.25,
              margin: "0 0 20px 0",
            }}
          >
            เสียงตอบรับจาก<br />ลูกค้า CTS
          </h2>

          {/* Description */}
          <p
            style={{
              fontSize: isDesktop ? "16px" : "14px",
              lineHeight: 1.7,
              color: "rgba(255,255,255,0.75)",
              margin: 0,
            }}
          >
            ลูกค้าไว้วางใจ CTS ด้วยบริการปกป้องรถยนต์ที่ครบวงจรและมาตรฐานสูง ทุกความประทับใจคือสิ่งที่เรามุ่งมั่นสูงสุด
          </p>
        </div>
      </div>

      {/* CTA */}
      <div
        style={{
          textAlign: "center",
          padding: "32px 20px 48px",
        }}
      >
        <LoanRegisterButton />
      </div>
    </section>
  );
};

export default FifthSection;
